/* @flow */
import React, { Component } from 'react'
import classNames from 'classnames'

import './Button.css'

type Props = {
	text?: string,
  loading?: boolean,
  error?: boolean,
  className?: string,
}

export default class Button extends Component<Props> {

  static state = {
    text: 'SUBMIT',
    loading: false,
    error: false,
    className: '',
  }

  classNames = () => {
    return classNames(
      [this.props.className],
      {
        loading: this.props.loading,
        'button-error': this.props.error
      }
    )
  }

  render() {
    return (
      <button type="submit" className={this.classNames()}>{this.props.text}</button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/Button/Button.js